export const CONCEPTS = {
  DEPOSIT: 'Depósito',
  TRANSFER_SINPE: 'Transferencia SINPE',
  CASH: 'Efectivo',
  TRANSFER: 'Transferencia',
  COLONES_DEPOSIT: 'Deposito en Colones',
  DOLLAR_DEPOSIT: 'Deposito en Dolares',
  CASH_IN_AGENT: 'Efectivo en Agente'
};
